/**
 * The supported image mime types in our project.
 * We restricted to only very widely used mime types to avoid unexpected errors.
 */
export enum ImageMimeType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
  GIF = 'image/gif',
}
